import { usePathname } from 'next/navigation';
import { useState } from 'react';

import { getShowPromoButtonAction } from '@/features/subscriptions/actions';
import { useMount } from '@/shared/hooks';

export const useShowPromoButton = () => {
	const pathname = usePathname();
	const [canViewPromoButton, setCanViewPromoButton] = useState(false);

	useMount(() => {
		getShowPromoButtonAction().then(setCanViewPromoButton);
	});

	const isCommunityPage = pathname === '/community';

	const onClick = () => {
		const priceAnchor = document.getElementById('price');
		if (priceAnchor) {
			priceAnchor.scrollIntoView({ behavior: 'smooth' });
		}
	};

	return {
		isCommunityPage,
		onClick,
		canViewPromoButton,
	};
};
